import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {ChatFeed} from './ChatUI';
import {withFirebase} from "../Firebase";

const Messages = ({messages, height}) => {



	return (
<Fragment>
	{messages.length > 0 &&
		<ChatFeed
			messages={messages}
			showSenderName
			maxHeight={height}
			bubbleStyles={{
				userBubble: {
					boxShadow: '0 0 6px rgba(0, 0, 0, .16)'
				},
				chatBubble: {
					boxShadow: '0 0 6px rgba(0, 0, 0, .16)'
				},
			}}
		/>}
</Fragment>
	);
};

Messages.propTypes = {
	messages: PropTypes.array,
	profile: PropTypes.object,
	height: PropTypes.string
};

Messages.defaultProps = {
	messages: [],
	profile: {id: 1},
	height: '60vh'
};

export default withFirebase(Messages);
